export const isValidCoordinate = (lat: number, lng: number) =>
  typeof lat === 'number' &&
  typeof lng === 'number' &&
  !isNaN(lat) &&
  !isNaN(lng) &&
  lat >= -90 &&
  lat <= 90 &&
  lng >= -180 &&
  lng <= 180;

export const getImpactedCustomersLabel = (
  impactedCustomers: number,
): string => {
  if (impactedCustomers > 999) {
    return '1k+';
  }
  if (impactedCustomers > 99) {
    return '99+';
  }
  return impactedCustomers.toString() || '';
};
